// src/hooks/useHauteurAuto.ts — SCE Issues
// Zone de texte qui grandit avec ce qu'on y écrit (29/10) : un commentaire de
// 15 lignes se relisait dans deux lignes. `rows` reste la hauteur de départ ;
// au-delà du plafond (45 % de la fenêtre, 360 px au plus), la zone défile.
// Remesurée à chaque frappe et quand sa largeur change (lignes repliées).
// Renvoie une ref de rappel : la zone peut n'apparaître qu'après le montage.

import { useEffect, useLayoutEffect, useState } from 'react'

const PLAFOND_PX = 360
const PLAFOND_FENETRE = 0.45

function ajuster(el: HTMLTextAreaElement): void {
  const plafond = Math.min(PLAFOND_PX, Math.round(window.innerHeight * PLAFOND_FENETRE))
  // 'auto' d'abord : sinon scrollHeight ne redescend jamais quand on efface.
  el.style.height = 'auto'
  const voulue = el.scrollHeight + (el.offsetHeight - el.clientHeight)
  el.style.height = `${Math.min(voulue, plafond)}px`
  el.style.overflowY = voulue > plafond ? 'auto' : 'hidden'
}

export function useHauteurAuto(valeur: string): (el: HTMLTextAreaElement | null) => void {
  const [zone, setZone] = useState<HTMLTextAreaElement | null>(null)

  useLayoutEffect(() => {
    if (zone) ajuster(zone)
  }, [zone, valeur])

  useEffect(() => {
    if (!zone) return
    let largeur = zone.clientWidth
    const observateur = new ResizeObserver(() => {
      if (zone.clientWidth === largeur) return
      largeur = zone.clientWidth
      ajuster(zone)
    })
    observateur.observe(zone)
    return () => observateur.disconnect()
  }, [zone])

  return setZone
}
